export const EmergencyFolderData = [
  {
    id: 1,
    name: "Medical History",
  },
  {
    id: 2,
    name: "Health Insurance",
  },
  {
    id: 3,
    name: "Blood Type",
  },
];
